<template>
  <v-container fluid>
    <h1 class="display-inline">Services Setup</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <p>This page is used to configure which WorkflowMax tasks are available for the capacity planner.</p>
    <p>Please enable the relevant tasks and give a "friendly" name to the task type as it should be presented in the capacity planner and
      reorder them to be in the order that they should show on interfaces.</p>

    <ServiceAdmin/>
  </v-container>
</template>

<script>

import ServiceAdmin from "@/components/capacity/ServiceAdmin.vue"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "AdminServices",
  permissions: [...ServiceAdmin.permissions],
  components: {ActiveApiCalls, ServiceAdmin},
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>